<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.supplierCharge')"
    width="1500px"
    :close-on-click-modal="false"
  >
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="20240305"
          :reset="true"
          :auto-init="searchItemAutoInit"
          :show-simple="false"
          :expand-adv="true"
          :custom-search-items="customSearchItems"
          @click-more="value=>isAdvancedQuery=value"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button no="button1" type="primary" @click="toPassChargeSyncOut()">{{ $t('SeaExport.confirmCharge') }}</el-button>
            <el-button no="button2" type="danger" @click="toNotPassChargeSyncOut()">{{ $t('SeaExport.Refuse') }}</el-button>
            <el-button no="button3" type="primary" @click="toRefresh()">{{ $t('SeaExport.Refresh') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="2024030501"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <div class="total-wrapper fixedBottom">
            <charge-currency-total-group
              ar-field="receivable"
              currency-field="currency"
              data-field="amount"
              :data-provider="selectedRows.length > 0 ? selectedRows : rowData"
              :ar-label="$t('Message.Receivable')"
              :ap-label="$t('Message.Payable')"
            />
          </div>
          <cargo-pagination
            config-module="990011"
            :total="total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQueryByPage"
          />
        </div>
        <!--拒绝-->
        <reject-dialog
          v-if="rejectWindow.visible"
          :visible.sync="rejectWindow.visible"
          :job-no="rejectWindow.jobNo"
          :reject-call-back="rejectWindow.rejectCallBack"
          :append-to-body="true"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import rejectDialog from '@/views/cargo/v0/AirExport/components/verify/rejectDialog.vue'
import {
  notPassChargeSyncOut,
  outChargeMatchSingle,
  passChargeSyncOut,
  supplierChargeAdvancedSearch
} from '@/api/clearing/chargeConfirmed'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch.vue'
import $store from '@/store'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ChargeCurrencyTotalGroup from '@/views/cargo/v0/Clearing/components/ChargeConfirmed/ChargeCurrencyTotalGroup'

export default {
  name: 'ChargeOutSyncRecordDialog',
  components: { searchItem, rejectDialog, ChargeCurrencyTotalGroup },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    chargeSyncCheckJobState: { type: Array, default: null },
    location: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      searchItemAutoInit: true,
      customSearchItems: [], // 自定义高级查询项
      isAdvancedQuery: false, // 记录上一次操作是否为高级查询
      total: 0,
      pageCount: 0,
      filter: {
        conditions: {},
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onSelectionChanged: event => {
          this.selectedRows = event.api.getSelectedRows()
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.source'),
          colId: 'pushSource',
          field: 'pushSource',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.chargeConfirmSourceOutLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.pushTime'),
          colId: 'pushTime',
          field: 'pushTime',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supplierOrderNo'),
          colId: 'supplierOrderNo',
          field: 'supplierOrderNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 180
        },
        {
          headerName: 'SO No.',
          colId: 'soNo',
          field: 'soNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 180
        },
        {
          headerName: 'HBL No.',
          colId: 'hblNo',
          field: 'hblNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supplierName'),
          colId: 'supplierName',
          field: 'supplierName',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supplierMatchName'),
          colId: 'supplierId',
          field: 'supplierId',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'),
          colId: 'amount',
          field: 'amount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          colId: 'taxUnitPrice',
          field: 'taxUnitPrice',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'),
          colId: 'taxRate',
          field: 'taxRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'supplierChargeItemId',
          field: 'supplierChargeItemId',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.chargeItemLocal'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('FinanceManage.currency'),
          colId: 'currency',
          field: 'currency',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.refMsg1'),
          colId: 'refMsg1',
          field: 'refMsg1',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.refMsg2'),
          colId: 'refMsg2',
          field: 'refMsg2',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supportNo'),
          colId: 'refNo',
          field: 'refNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          colId: 'remark',
          field: 'remark',
          width: 180
        },
        {
          headerName: this.$t('Clearing.ConfirmationStatus'),
          colId: 'chargeConfirmState',
          field: 'chargeConfirmState',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.chargeConfirmStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.auditOperationTime'),
          colId: 'verifiedTime',
          field: 'verifiedTime',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.AuditOperator'),
          field: 'verifiedBy',
          colId: 'verifiedBy',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'rejectReason',
          field: 'rejectReason',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ARAP'),
          field: 'receivable',
          colId: 'receivable',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.arApLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      selectedRows: [],
      refreshCharge: false,
      rejectWindow: {
        visible: false,
        jobNo: null,
        rejectCallBack: null
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.refreshCharge = false
          this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.$emit('callback', this.refreshCharge)
        this.rowData = []
      }
    }
  },
  methods: {
    init() {
      this.toQueryByPage()
    },
    // 分页查询
    toQueryByPage() {
      this.toAdvancedQuery()
    },
    // 高级查询
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
      }
      this.doAdvancedQuery(data)
    },
    doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.loading = getLoading()
      this.filterJson.jobNo = this.job.jobNo
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = $store.getters.currentOfficeId
      supplierChargeAdvancedSearch(this.filterJson).then(res => {
        this.handleQueryData(res)
      }).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
    },
    toPassChargeSyncOut() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (this.chargeSyncCheckJobState) {
        for (const row of selectedRows) {
          if (!this.chargeSyncCheckJobState.includes(row.jobState)) {
            this.$message.warning(this.$t('Message.ChargeSyncJobStateCheckFail'))
            return
          }
        }
      } else {
        for (const row of selectedRows) {
          if (row.jobState !== 0) {
            this.$message.warning(this.$t('FinanceManage.businessHasBeenSubmitted'))
            return
          }
        }
      }
      for (const row of selectedRows) {
        if (!row.supplierId || !row.chargeItemId) {
          this.$message.warning(this.$t('SeaExport.PleaseRefreshThePage'))
          return
        }
      }
      if (!this.checkConfirmedData()) {
        return
      }
      this.$confirm(this.$t('SeaExport.ConfirmReceiveTheseCharges'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'info'
      }).then(() => {
        const loading = getLoading4Cxt(this)
        passChargeSyncOut(selectedRows).then(res => {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.toQueryByPage()
          this.refreshCharge = true
        }).finally(() => {
          if (loading) {
            loading.close()
          }
        })
      }).catch(() => {
      })
    },
    checkConfirmedData() {
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = []
      let flag = selectedRows.length > 0
      if (flag) {
        for (const row of selectedRows) {
          if (row.chargeConfirmState !== SystemConstants.WAITING_CONFIRMATION_OUT.code) {
            flag = false
            break
          }
          keys.push(row.uuid)
        }
      }
      if (flag) {
        flag = keys.length > 0
      }
      if (!flag) {
        this.$message.warning(this.$t('SeaExport.selectBeConfirmedCharge'))
      }
      return flag
    },
    // 审核不通过
    toNotPassChargeSyncOut() {
      if (!this.checkConfirmedData()) {
        return
      }
      this.rejectWindow.rejectCallBack = this.rejectFunc
      this.rejectWindow.visible = true
    },
    // 重新匹配外部推送费用关联的业务
    toRefresh() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const loading = getLoading4Cxt(this)
      const keys = Array.from(selectedRows, p => p.uuid)
      outChargeMatchSingle(keys).then(res => {
        this.$message.success(this.$t('SeaExport.RefreshSuccessfulRows', [res.data]))
        this.toQueryByPage()
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    rejectFunc(reason) {
      if (!reason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReasonNotEntered'))
        return false
      }
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = Array.from(selectedRows, p => p.uuid)
      const loading = getLoading4Cxt(this)
      notPassChargeSyncOut(keys, { reason: reason }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.toQueryByPage()
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    }
  }
}
</script>
